export const locales = {
  en: {
    shared: {
      btnOK: 'OK',
      btnCancel: 'Cancel',
      btnYes: 'Yes',
      btnNo: 'No',
      dialogClose: 'Close dialog',
      dialogRestore: 'Restore position',
      wordYou: 'You',
      wordUnknown: 'Unknown',
      wordGold: 'Gold',
      wordSubmit: 'Submit',
      wordBack: 'Back',
      itemFallbackName: 'Item {id}',
    },
    mainMenu: {
      inputHost: 'wss://ws.reoserv.net',
      btnCreateAccount: 'Create Account',
      btnLogin: 'Login',
      btnViewCredits: 'View Credits',
      logoAlt: 'Endless Online',
    },
    login: {
      title: 'Login to Your Account',
      username: 'Username',
      password: 'Password',
      remember: 'Remember Me',
      btnConnect: 'Connect',
    },
    selectSession: {
      title: 'Select Account',
      btnPlay: 'Play',
      btnDelete: 'Delete',
      btnLoginDifferent: 'Login to Different Account',
      btnBack: 'Back',
      confirmDeleteTitle: 'Delete Saved Session',
      confirmDelete: 'Remove saved session for "{0}"?',
      lastLoginJustNow: 'Just now',
      lastLoginMinutesAgo: '{0}m ago',
      lastLoginHoursAgo: '{0}h ago',
      lastLoginDaysAgo: '{0}d ago',
    },
    createAccount: {
      title: 'Create Account',
      username: 'Username',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      fullName: 'Full Name',
      location: 'Location',
      email: 'Email',
      btn: 'Create Account',
    },
    changePassword: {
      title: 'Change Password',
      username: 'Username',
      oldPassword: 'Old Password',
      newPassword: 'New Password',
      confirmPassword: 'Confirm New Password',
      btn: 'Change Password',
    },
    characterSelect: {
      title: 'Select Your Character',
      emptySlot: 'Empty Slot',
      btnNew: 'New Character',
      btnLogin: 'Login',
      btnDelete: 'Delete',
    },
    createCharacter: {
      title: 'Create Character',
      name: 'Name',
      gender: 'Gender',
      hairStyle: 'Hair Style',
      hairColor: 'Hair Color',
      skin: 'Skin',
      female: 'Female',
      male: 'Male',
      btn: 'Create',
    },
    hud: {
      hp: 'HP',
      tp: 'TP',
      tnl: 'TNL',
      weight: 'Weight',
      lvl: 'Lv',
    },
    character: {
      title: 'Character',
      tabPaperdoll: 'Paperdoll',
      tabStats: 'Stats',
      tabBook: 'Book',
      labelName: 'Name',
      labelTitle: 'Title',
      labelHome: 'Home',
      labelPartner: 'Partner',
      labelGuild: 'Guild',
      labelRank: 'Rank',
      labelClass: 'Class',
      labelAdmin: 'Admin',
      bookNoQuests: 'No completed quests',
    },
    stats: {
      labelBase: 'Base',
      labelDerived: 'Derived',
      labelStr: 'STR',
      labelInt: 'INT',
      labelWis: 'WIS',
      labelAgi: 'AGI',
      labelCon: 'CON',
      labelCha: 'CHA',
      labelDmg: 'Damage',
      labelAccuracy: 'Accuracy',
      labelEvade: 'Evade',
      labelArmor: 'Armor',
      statPoints: 'Stat Points: {count}',
      trainBtn: '+',
    },
    equipment: {
      hat: 'Hat',
      necklace: 'Necklace',
      armor: 'Armor',
      weapon: 'Weapon',
      shield: 'Shield',
      gloves: 'Gloves',
      belt: 'Belt',
      boots: 'Boots',
      accessory: 'Accessory',
      ring1: 'Ring 1',
      ring2: 'Ring 2',
      armlet1: 'Armlet 1',
      armlet2: 'Armlet 2',
      bracer1: 'Bracer 1',
      bracer2: 'Bracer 2',
    },
    admin: {
      badgeSpy: 'SPY',
      badgeLightGuide: 'GUIDE',
      badgeGuardian: 'GUARD',
      badgeGameMaster: 'GM',
      badgeHighGameMaster: 'HGM',
      lightGuide: 'Light Guide',
      guardian: 'Guardian',
      gameMaster: 'Game Master',
      highGameMaster: 'High GM',
      spy: 'Spy',
    },
    inventory: {
      title: 'Inventory',
      tab1: 'I',
      tab2: 'II',
      ctxUse: 'Use',
      ctxDrop: 'Drop',
      ctxJunk: 'Junk',
      ctxAssignSlot: 'Assign Slot',
      junkConfirmTitle: 'Junk Item',
      junkConfirmMessage: 'Are you sure you want to junk {name}?',
      junkDropZone: 'Junk Item',
      dropZone: 'Drop Item',
    },
    settings: {
      title: 'Settings',
      tabGraphics: 'Graphics',
      tabInterface: 'Interface',
      tabSound: 'Sound',
      tabSocial: 'Social',
      tabHud: 'HUD',
      tabDebug: 'Debug',
      tabAdvanced: 'Advanced',
      fpsLimit: 'FPS Limit',
      fpsUnlimited: 'Unlimited',
      interpolation: 'Frame Interpolation',
      zoom: 'Zoom',
      zoomReset: 'Reset',
      zoomOut: 'Zoom out',
      zoomIn: 'Zoom in',
      uiScale: 'UI Scale',
      gameZoom: 'Game Zoom',
      theme: 'Theme',
      language: 'Language',
      backdropBlur: 'Backdrop Blur',
      combatNpcGhosting: 'Combat NPC Ghosting',
      combatNpcGhostingHint:
        'Allow walking and click-pathing through passive/aggressive NPCs.',
      touchReposition: 'Reposition Touch Controls',
      touchRepositionHint: 'Drag touch controls to reposition them on screen.',
      mobileControls: 'Mobile Controls',
      mobileJoystick: 'Joystick',
      mobileMovementMode: 'Movement Pad',
      mobileMovementJoystick: 'Joystick',
      mobileMovementDpad: 'D-pad',
      mobileActionButtons: 'Action Buttons',
      desktopEmoteButton: 'Desktop Emote Button',
      visibility_auto: 'Auto',
      visibility_always: 'Always',
      visibility_never: 'Never',
      resetPositions: 'Reset UI Positions',
      resetPositionsHint:
        'Reset all UI positions and layout settings back to defaults.',
      moveUp: 'Move up',
      moveDown: 'Move down',
      masterVolume: 'Master Volume',
      effectVolume: 'Effect Volume',
      ambientVolume: 'Ambient Volume',
      musicVolume: 'Music Volume',
      musicForceLoop: 'Always Loop Music',
      musicForceLoopHint:
        'Forces map music tracks to loop even when they are not set to loop.',
      whispers: 'Whispers',
      tradeRequests: 'Trade Requests',
      partyRequests: 'Party Requests',
      profanityFilter: 'Profanity Filter',
      chatLog: 'Chat Log',
      socialAll: 'All',
      socialFriends: 'Friends',
      socialNone: 'None',
      hudPerCharNote: 'These settings are saved per character.',
      hudWidget: 'Widget',
      hudVisible: 'Visible',
      hudPosition: 'Position',
      hudOrder: 'Order',
      hudLeft: 'Left',
      hudCenter: 'Center',
      hudRight: 'Right',
      hudWidgetCharacter: 'Character',
      hudWidgetHp: 'HP',
      hudWidgetTp: 'TP',
      hudWidgetTnl: 'TNL',
      hudWidgetWeight: 'Weight',
      hudWidgetPing: 'Ping',
      debugMapLayers: 'Map Layers',
      debugLayerGround: 'Ground',
      debugLayerObjects: 'Objects',
      debugLayerOverlay: 'Overlay',
      debugLayerDownWall: 'Down Wall',
      debugLayerRightWall: 'Right Wall',
      debugLayerRoof: 'Roof',
      debugLayerTop: 'Top',
      debugLayerShadow: 'Shadow',
      debugLayerOverlay2: 'Overlay 2',
      debugPacketLog: 'Packet Log',
      advancedStorage: 'App Storage',
      advancedLocalStorage: 'Settings (localStorage)',
      advancedIndexedDB: 'Cache (IndexedDB)',
      advancedRefresh: 'Refresh',
      advancedClearHint:
        'Clear cached game data (maps, pub files, chat history). Your settings are preserved.',
      advancedClearCache: 'Clear Cache',
      advancedClearConfirm:
        'Clear all cached game data? This will delete maps, pub files, and chat history. Your settings will be kept.',
      advancedCleared: 'Cache cleared successfully.',
    },
    packetLog: {
      title: 'Packet Log',
      clear: 'Clear',
      source: 'Source',
      family: 'Family',
      action: 'Action',
      time: 'Time',
      data: 'Data',
      empty: 'No packets captured yet.',
      client: 'Client',
      server: 'Server',
      sensitive: 'Sensitive',
      showSensitive: 'Show sensitive data',
      hideSensitive: 'Hide sensitive data',
      detailTitle: 'Packet Detail',
      detailClose: 'Close',
      detailJson: 'Parsed',
      detailHex: 'Hex',
      unknownPacket: 'Unknown packet (no parser)',
    },
    chat: {
      tapToChat: 'Tap to chat…',
      pressEnterToChat: 'Press enter to chat…',
      logAriaLabel: 'Chat log',
      openChannelInNewTab: 'Open channel in new tab',
      readOnly: 'Read-only channel',
      saySomething: 'Say something...',
      sendTo: 'Send to {name}...',
      closeTab: 'Close {name}',
      noMessages: 'No messages yet.',
    },
    chatLog: {
      title: 'Chat Log',
      allChannels: 'All Channels',
      local: 'Local',
      global: 'Global',
      party: 'Party',
      guild: 'Guild',
      admin: 'Admin',
      system: 'System',
      private: 'Private Messages',
      export: 'Export',
      plainText: 'Plain Text',
      json: 'JSON',
      csv: 'CSV',
      clearAll: 'Clear All',
      clearTitle: 'Clear Chat Log',
      clearMessage: 'Delete all saved chat messages? This cannot be undone.',
      searchPlaceholder: 'Search name or message…',
      sortOldestFirst: 'Oldest first',
      sortNewestFirst: 'Newest first',
      sortOldest: 'Oldest',
      sortNewest: 'Newest',
      loading: 'Loading…',
      noMessages: 'No messages found.',
      deleteMessage: 'Delete message',
      noMessagesShort: 'No messages',
      pagination: 'Page {page} of {totalPages} · {total} total',
    },
    chest: {
      title: 'Chest',
      empty: 'The chest is empty',
      depositHow: 'How many to deposit?',
      deposit: 'Deposit',
      depositedMsg: 'Added {amount}x {name} to chest',
      tookMsg: 'Took {amount}x {name} from chest',
    },
    locker: {
      title: 'Bank Locker',
      empty: 'Your locker is empty',
      deposit: 'Deposit',
      withdraw: 'Withdraw',
      searchPlaceholder: 'Search items…',
      filterAll: 'All',
      filterWeapon: 'Weapon',
      filterArmor: 'Armor',
      filterAccessory: 'Accessory',
      filterConsumable: 'Consumable',
      filterOther: 'Other',
      depositedMsg: 'Deposited {amount}x {name} to locker',
      tookMsg: 'Took {amount}x {name} from locker',
      upgradedMsg: 'Locker upgraded!',
    },
    bank: {
      title: 'Bank',
      balance: 'Balance',
      onHand: 'On hand',
      deposit: 'Deposit',
      withdraw: 'Withdraw',
      lockerUpgrades: 'Locker upgrades',
      buyUpgrade: 'Buy upgrade',
      nextUpgradeCost: 'Next upgrade cost',
      maxLockerItems: 'Max locker items',
      depositedMsg: 'Deposited {amount} gold to bank',
      withdrewMsg: 'Withdrew {amount} gold from bank',
    },
    shop: {
      title: 'Shop',
      tabBuy: 'Buy',
      tabSell: 'Sell',
      tabCraft: 'Craft',
      buyPrice: 'Buy price',
      sellPrice: 'Sell price',
      youHave: 'You have',
      buyAction: 'Buy',
      buyAgainAction: 'Buy More',
      sellAction: 'Sell',
      sellAllAction: 'Sell All',
      craftAction: 'Craft',
      buyEmpty: 'This shop has no items to buy.',
      sellEmpty: 'You do not have items this shop can buy.',
      craftEmpty: 'This shop has no crafts.',
      ingredients: 'Ingredients',
      noIngredients: 'No ingredients required.',
      boughtMsg: 'Bought {amount}x {name}',
      soldMsg: 'Sold {amount}x {name}',
      craftedMsg: 'Crafted {name}',
    },
    trade: {
      title: 'Trade',
      addItem: 'Add Item',
      yourItems: 'Your Items',
      partnerItems: "{name}'s Items",
      agreed: 'Agreed',
      notAgreed: 'Not Agreed',
      scamWarning: 'WARNING: Items have been changed!',
      searchPlaceholder: 'Search items...',
      dropHowMany: 'How many to trade?',
      partnerNoItems: '{name} has not offered any items.',
      yourNoItems: 'You have not offered any items.',
      drop: 'Trade',
      agree: 'Agree',
      btnUnagree: 'Unagree',
    },
    skillMaster: {
      learnTab: 'Learn',
      forgetTab: 'Forget',
      learnBtn: 'Learn',
      forgetBtn: 'Forget',
      resetBtn: 'Reset Character',
      noSkillsToLearn: 'There are no skills available to learn.',
      noSkillsLearned: 'You have not learned any skills.',
      cost: 'Cost',
      levelReq: 'Level',
      classReq: 'Class',
      statStr: 'STR',
      statIntl: 'INT',
      statWis: 'WIS',
      statAgi: 'AGI',
      statCon: 'CON',
      statCha: 'CHA',
      gold: 'gold',
      skillReq: 'Requires',
      learnedMsg: 'Learned {name}',
      forgotMsg: 'Forgot {name}',
      resetMsg: 'Character has been reset',
    },
    spells: {
      title: 'Spells',
      comingSoon: 'Spells coming soon',
      noSpells: 'No spells learned yet',
      skillPoints: 'Skill Points: {count}',
      level: 'Lv {level}',
      trainBtn: 'Train',
      dragHint: 'Drag to hotbar',
      trainedMsg: '{name} trained to level {level}',
    },
    quests: {
      title: 'Quests',
      comingSoon: 'Quests coming soon',
      tabActive: 'Active',
      tabHistory: 'History',
      track: 'Track',
      noActive: 'No active quests',
      noHistory: 'No completed quests',
      trackerTitle: 'Quest Tracker',
      npcOk: 'OK',
      npcSwitch: 'Switch Quest',
    },
    party: {
      panelTitle: 'Party',
      panelLeave: 'Leave party',
      panelKick: 'Kick from party',
      leader: 'Leader',
    },
    social: {
      title: 'Social',
      whisper: 'Whisper',
      removeFriend: 'Remove Friend',
      addFriend: 'Add Friend',
      unignore: 'Unignore',
      ignore: 'Ignore',
      online: 'Online ({count})',
      friends: 'Friends ({count})',
      guild: 'Guild ({count})',
      ignored: 'Ignored ({count})',
    },
    jukebox: {
      noSongs: 'No songs available',
      nowPlaying: 'Now playing: {track}',
    },
    bard: {
      title: 'Bard Skill',
      noInstrument: 'You need an instrument equipped to use bard skills.',
    },
    barber: {
      title: 'Barber',
      hairStyle: 'Hair Style',
      hairColor: 'Hair Color',
      showHat: 'Show Hat',
      cost: 'Cost',
      buy: 'Buy',
      bald: 'Bald',
      confirmTitle: 'Change Hairstyle',
      confirmMessage: 'Are you sure you want to change your hairstyle?',
    },
    innKeeper: {
      title: 'Inn',
      becomeCitizen: 'Become Citizen',
      giveUpCitizenship: 'Give Up Citizenship',
      sleep: 'Sleep',
      becameCitizenMsg: 'You are now a citizen!',
      wrongAnswersMsg: 'Some answers were wrong. Try again.',
      gaveUpCitizenshipMsg: 'You have given up your citizenship.',
      notCitizenMsg: 'You are not a citizen here.',
      sleptMsg: 'You feel well rested.',
      confirmGiveUpTitle: 'Give Up Citizenship',
      confirmGiveUpMsg: 'Are you sure you want to give up your citizenship?',
    },
    law: {
      title: 'Lawyer',
    },
    board: {
      title: 'Town Board',
      newPost: 'New Post',
      postSubject: 'Subject',
      postBody: 'Body',
      postSubmit: 'Submit',
      postCancel: 'Cancel',
      postBack: 'Back',
      deletePost: 'Delete',
      noPosts: 'No posts yet.',
      postBy: 'by {author}',
      deleteConfirmTitle: 'Delete Post',
      deleteConfirmMsg: 'Are you sure you want to delete this post?',
    },
    guild: {
      title: 'Guild',
      tabRegistration: 'Registration',
      tabCreate: 'Create',
      tabManagement: 'Management',
      tabLookup: 'Lookup',
      createTitle: 'Create Guild',
      createTag: 'Tag (3 chars)',
      createName: 'Name',
      createDescription: 'Description',
      createSubmit: 'Begin Creation',
      joinTitle: 'Join Guild',
      joinTag: 'Guild Tag',
      joinRecruiter: 'Recruiter Name',
      joinSubmit: 'Request to Join',
      currentGuild: 'Current Guild',
      leave: 'Leave Guild',
      disband: 'Disband Guild',
      leaveConfirmTitle: 'Leave Guild',
      leaveConfirmMessage: 'Are you sure you want to leave your guild?',
      disbandConfirmTitle: 'Disband Guild',
      disbandConfirmMessage:
        'Are you sure you want to disband the guild? This cannot be undone.',
      creatingTitle: 'Guild Creation In Progress',
      creatingWaiting: 'Waiting for members to accept...',
      creatingMembers: 'Accepted Members',
      manageDescription: 'Edit Description',
      manageRanks: 'Edit Rank Names',
      manageBank: 'Guild Bank',
      manageKick: 'Kick Member',
      manageAssignRank: 'Change Member Rank',
      save: 'Save',
      back: 'Back',
      bankBalance: 'Bank Balance',
      bankDeposit: 'Deposit',
      bankAmount: 'Amount',
      kickName: 'Member Name',
      kickSubmit: 'Kick',
      assignRankName: 'Member Name',
      assignRankValue: 'Rank (0-9)',
      assignRankSubmit: 'Assign Rank',
      rankLabel: 'Rank {n}',
      lookupSearch: 'Tag or Name',
      lookupInfo: 'Guild Info',
      lookupMembers: 'Member List',
      lookupName: 'Name',
      lookupTag: 'Tag',
      lookupDescription: 'Description',
      lookupWealth: 'Wealth',
      lookupCreated: 'Founded',
      lookupStaff: 'Staff',
      lookupRank: 'Rank',
      lookupMember: 'Member',
      notMember: 'You are not in a guild.',
    },
    ping: {
      dialogTitle: 'Ping',
      dialogMin: 'Min',
      dialogMax: 'Max',
      dialogAvg: 'Avg',
      ms: 'ms',
      dialogNoData: 'Waiting for data...',
    },
    cmdPalette: {
      searchPlaceholder: 'Search commands…',
      navigate: 'navigate',
      run: 'run',
      close: 'close',
      noResults: 'No commands found',
      recentlyUsed: 'Recently Used',
      results: 'Results',
      all: 'Commands',
    },
    messages: {
      killedNpc: '{killer} killed {npc}!',
      gainedExp: 'You gained {exp} EXP!',
      npcDrop: 'Dropped {item}!',
      expShare: 'You gained {exp} EXP from party share!',
      levelUp: 'Congratulations! You reached level {level}!',
    },
    lang: {
      en: 'English',
      nl: 'Dutch',
      sv: 'Swedish',
      pt: 'Portugese',
    },
    nav: {
      inventory: 'Inventory',
      map: 'Map',
      spells: 'Spells',
      character: 'Character',
      quests: 'Quests',
      social: 'Social',
      bot: 'Bot',
      discord: 'Discord',
      settings: 'Settings',
      refresh: 'Refresh',
      exit: 'Exit',
    },
  },
  nl: {
    shared: {
      btnOK: 'OK',
      btnCancel: 'Annuleren',
      btnYes: 'Ja',
      btnNo: 'Nee',
      dialogClose: 'Dialoog sluiten',
      dialogRestore: 'Positie herstellen',
      wordYou: 'Jij',
      wordUnknown: 'Onbekend',
      wordGold: 'Goud',
      wordSubmit: 'Verzenden',
      wordBack: 'Terug',
      itemFallbackName: 'Item {id}',
    },
    mainMenu: {
      inputHost: 'wss://ws.reoserv.net',
      btnCreateAccount: 'Account aanmaken',
      btnLogin: 'Inloggen',
      btnViewCredits: 'Credits bekijken',
      logoAlt: 'Endless Online',
    },
    login: {
      title: 'Inloggen op uw account',
      username: 'Gebruikersnaam',
      password: 'Wachtwoord',
      remember: 'Onthoud mij',
      btnConnect: 'Verbinden',
    },
    selectSession: {
      title: 'Account selecteren',
      btnPlay: 'Spelen',
      btnDelete: 'Verwijderen',
      btnLoginDifferent: 'Inloggen met ander account',
      btnBack: 'Terug',
      confirmDeleteTitle: 'Opgeslagen sessie verwijderen',
      confirmDelete: 'Opgeslagen sessie voor "{0}" verwijderen?',
      lastLoginJustNow: 'Zojuist',
      lastLoginMinutesAgo: '{0}m geleden',
      lastLoginHoursAgo: '{0}u geleden',
      lastLoginDaysAgo: '{0}d geleden',
    },
    createAccount: {
      title: 'Account aanmaken',
      username: 'Gebruikersnaam',
      password: 'Wachtwoord',
      confirmPassword: 'Wachtwoord bevestigen',
      fullName: 'Volledige naam',
      location: 'Locatie',
      email: 'E-mail',
      btn: 'Account aanmaken',
    },
    changePassword: {
      title: 'Wachtwoord wijzigen',
      username: 'Gebruikersnaam',
      oldPassword: 'Oud wachtwoord',
      newPassword: 'Nieuw wachtwoord',
      confirmPassword: 'Nieuw wachtwoord bevestigen',
      btn: 'Wachtwoord wijzigen',
    },
    characterSelect: {
      title: 'Selecteer uw personage',
      emptySlot: 'Lege plek',
      btnNew: 'Nieuw personage',
      btnLogin: 'Inloggen',
      btnDelete: 'Verwijderen',
    },
    createCharacter: {
      title: 'Personage aanmaken',
      name: 'Naam',
      gender: 'Geslacht',
      hairStyle: 'Haarstijl',
      hairColor: 'Haarkleur',
      skin: 'Huid',
      female: 'Vrouw',
      male: 'Man',
      btn: 'Aanmaken',
    },
    hud: {
      hp: 'HP',
      tp: 'TP',
      tnl: 'TNL',
      weight: 'Gewicht',
      lvl: 'Nv',
    },
    character: {
      title: 'Personage',
      tabPaperdoll: 'Paperpop',
      tabStats: 'Statistieken',
      tabBook: 'Boek',
      labelName: 'Naam',
      labelTitle: 'Titel',
      labelHome: 'Thuis',
      labelPartner: 'Partner',
      labelGuild: 'Gilde',
      labelRank: 'Rang',
      labelClass: 'Klasse',
      labelAdmin: 'Admin',
      bookNoQuests: 'Geen voltooide quests',
    },
    stats: {
      labelBase: 'Basis',
      labelDerived: 'Afgeleid',
      labelStr: 'STR',
      labelInt: 'INT',
      labelWis: 'WIS',
      labelAgi: 'BEH',
      labelCon: 'CON',
      labelCha: 'KAR',
      labelDmg: 'Schade',
      labelAccuracy: 'Nauwkeurigheid',
      labelEvade: 'Ontwijken',
      labelArmor: 'Pantser',
      statPoints: 'Statistiekpunten: {count}',
      trainBtn: '+',
    },
    equipment: {
      hat: 'Hoed',
      necklace: 'Ketting',
      armor: 'Pantser',
      weapon: 'Wapen',
      shield: 'Schild',
      gloves: 'Handschoenen',
      belt: 'Riem',
      boots: 'Laarzen',
      accessory: 'Accessoire',
      ring1: 'Ring 1',
      ring2: 'Ring 2',
      armlet1: 'Armband 1',
      armlet2: 'Armband 2',
      bracer1: 'Polsband 1',
      bracer2: 'Polsband 2',
    },
    admin: {
      badgeSpy: 'SPY',
      badgeLightGuide: 'GIDS',
      badgeGuardian: 'BEWK',
      badgeGameMaster: 'GM',
      badgeHighGameMaster: 'HGM',
      lightGuide: 'Lichtgids',
      guardian: 'Bewaker',
      gameMaster: 'Spelmeester',
      highGameMaster: 'Hoge GM',
      spy: 'Spion',
    },
    inventory: {
      title: 'Inventaris',
      tab1: 'I',
      tab2: 'II',
      ctxUse: 'Gebruiken',
      ctxDrop: 'Droppen',
      ctxJunk: 'Weggooien',
      ctxAssignSlot: 'Slot toewijzen',
      junkConfirmTitle: 'Item weggooien',
      junkConfirmMessage: 'Weet je zeker dat je {name} wilt weggooien?',
      junkDropZone: 'Item weggooien',
      dropZone: 'Item droppen',
    },
    settings: {
      title: 'Instellingen',
      tabGraphics: 'Grafisch',
      tabInterface: 'Interface',
      tabSound: 'Geluid',
      tabSocial: 'Sociaal',
      tabHud: 'HUD',
      tabDebug: 'Debug',
      tabAdvanced: 'Geavanceerd',
      fpsLimit: 'FPS-limiet',
      fpsUnlimited: 'Onbeperkt',
      interpolation: 'Frame-interpolatie',
      zoom: 'Zoom',
      zoomReset: 'Herstel',
      zoomOut: 'Uitzoomen',
      zoomIn: 'Inzoomen',
      uiScale: 'UI-schaal',
      gameZoom: 'Game Zoom',
      theme: 'Thema',
      language: 'Taal',
      backdropBlur: 'Achtergrondvervaging',
      combatNpcGhosting: 'Gevechts-NPC ghosting',
      combatNpcGhostingHint:
        'Sta lopen en klikroutes door passieve/agressieve NPCs toe.',
      touchReposition: 'Bedieningselementen herplaatsen',
      touchRepositionHint:
        'Sleep touch-bedieningselementen om ze op het scherm te herplaatsen.',
      mobileControls: 'Mobiele bediening',
      mobileJoystick: 'Joystick',
      mobileMovementMode: 'Movement Pad',
      mobileMovementJoystick: 'Joystick',
      mobileMovementDpad: 'D-pad',
      mobileActionButtons: 'Actieknoppen',
      desktopEmoteButton: 'Emote-knop (desktop)',
      visibility_auto: 'Auto',
      visibility_always: 'Altijd',
      visibility_never: 'Nooit',
      resetPositions: 'UI-posities herstellen',
      resetPositionsHint:
        'Alle UI-posities en lay-outinstellingen terugzetten naar standaard.',
      moveUp: 'Omhoog verplaatsen',
      moveDown: 'Omlaag verplaatsen',
      masterVolume: 'Hoofdvolume',
      effectVolume: 'Effectvolume',
      ambientVolume: 'Omgevingsvolume',
      musicVolume: 'Muziekvolume',
      musicForceLoop: 'Muziek altijd herhalen',
      musicForceLoopHint:
        'Dwingt kaartmuziek om te herhalen, ook als dat niet is ingesteld.',
      whispers: 'Fluisterberichten',
      tradeRequests: 'Handelsverzoeken',
      partyRequests: 'Groepsverzoeken',
      profanityFilter: 'Vulgairheidsfilter',
      chatLog: 'Chatlogboek',
      socialAll: 'Alles',
      socialFriends: 'Vrienden',
      socialNone: 'Geen',
      hudPerCharNote: 'Deze instellingen worden per personage opgeslagen.',
      hudWidget: 'Widget',
      hudVisible: 'Zichtbaar',
      hudPosition: 'Positie',
      hudOrder: 'Volgorde',
      hudLeft: 'Links',
      hudCenter: 'Midden',
      hudRight: 'Rechts',
      hudWidgetCharacter: 'Personage',
      hudWidgetHp: 'HP',
      hudWidgetTp: 'TP',
      hudWidgetTnl: 'TNL',
      hudWidgetWeight: 'Gewicht',
      hudWidgetPing: 'Ping',
      debugMapLayers: 'Kaartlagen',
      debugLayerGround: 'Grond',
      debugLayerObjects: 'Objecten',
      debugLayerOverlay: 'Overlay',
      debugLayerDownWall: 'Muur beneden',
      debugLayerRightWall: 'Muur rechts',
      debugLayerRoof: 'Dak',
      debugLayerTop: 'Boven',
      debugLayerShadow: 'Schaduw',
      debugLayerOverlay2: 'Overlay 2',
      debugPacketLog: 'Pakketlog',
      advancedStorage: 'App-opslag',
      advancedLocalStorage: 'Instellingen (localStorage)',
      advancedIndexedDB: 'Cache (IndexedDB)',
      advancedRefresh: 'Vernieuwen',
      advancedClearHint:
        'Gecachte speldata verwijderen (kaarten, pub-bestanden, chatgeschiedenis). Uw instellingen blijven bewaard.',
      advancedClearCache: 'Cache wissen',
      advancedClearConfirm:
        'Alle gecachte speldata wissen? Dit verwijdert kaarten, pub-bestanden en chatgeschiedenis. Uw instellingen blijven bewaard.',
      advancedCleared: 'Cache succesvol gewist.',
    },
    packetLog: {
      title: 'Pakketlog',
      clear: 'Wissen',
      source: 'Bron',
      family: 'Familie',
      action: 'Actie',
      time: 'Tijd',
      data: 'Data',
      empty: 'Nog geen pakketten vastgelegd.',
      client: 'Client',
      server: 'Server',
      sensitive: 'Gevoelig',
      showSensitive: 'Gevoelige data tonen',
      hideSensitive: 'Gevoelige data verbergen',
      detailTitle: 'Pakketdetail',
      detailClose: 'Sluiten',
      detailJson: 'Verwerkt',
      detailHex: 'Hex',
      unknownPacket: 'Onbekend pakket (geen parser)',
    },
    chat: {
      tapToChat: 'Tik om te chatten…',
      pressEnterToChat: 'Druk op Enter om te chatten…',
      logAriaLabel: 'Chatlogboek',
      openChannelInNewTab: 'Kanaal openen in nieuw tabblad',
      readOnly: 'Alleen-lezen kanaal',
      saySomething: 'Zeg iets...',
      sendTo: 'Stuur naar {name}...',
      closeTab: '{name} sluiten',
      noMessages: 'Nog geen berichten.',
    },
    chatLog: {
      title: 'Chatlogboek',
      allChannels: 'Alle kanalen',
      local: 'Lokaal',
      global: 'Globaal',
      party: 'Groep',
      guild: 'Gilde',
      admin: 'Admin',
      system: 'Systeem',
      private: 'Privéberichten',
      export: 'Exporteren',
      plainText: 'Platte tekst',
      json: 'JSON',
      csv: 'CSV',
      clearAll: 'Alles wissen',
      clearTitle: 'Chatlogboek wissen',
      clearMessage:
        'Alle opgeslagen chatberichten verwijderen? Dit kan niet ongedaan worden gemaakt.',
      searchPlaceholder: 'Naam of bericht zoeken…',
      sortOldestFirst: 'Oudste eerst',
      sortNewestFirst: 'Nieuwste eerst',
      sortOldest: 'Oudste',
      sortNewest: 'Nieuwste',
      loading: 'Laden…',
      noMessages: 'Geen berichten gevonden.',
      deleteMessage: 'Bericht verwijderen',
      noMessagesShort: 'Geen berichten',
      pagination: 'Pagina {page} van {totalPages} · {total} totaal',
    },
    chest: {
      title: 'Kist',
      empty: 'De kist is leeg',
      depositHow: 'Hoeveel wil je deponeren?',
      deposit: 'Deponeren',
      depositedMsg: '{amount}x {name} toegevoegd aan kist',
      tookMsg: '{amount}x {name} uit kist gehaald',
    },
    locker: {
      title: 'Bankkluis',
      empty: 'Uw kluis is leeg',
      deposit: 'Deponeren',
      withdraw: 'Opnemen',
      searchPlaceholder: 'Items zoeken…',
      filterAll: 'Alles',
      filterWeapon: 'Wapen',
      filterArmor: 'Pantser',
      filterAccessory: 'Accessoire',
      filterConsumable: 'Verbruiksartikel',
      filterOther: 'Overig',
      depositedMsg: '{amount}x {name} in kluis gedeponeerd',
      tookMsg: '{amount}x {name} uit kluis gehaald',
      upgradedMsg: 'Kluis uitgebreid!',
    },
    bank: {
      title: 'Bank',
      balance: 'Saldo',
      onHand: 'Bij de hand',
      deposit: 'Deponeren',
      withdraw: 'Opnemen',
      lockerUpgrades: 'Kluisuitbreidingen',
      buyUpgrade: 'Uitbreiding kopen',
      nextUpgradeCost: 'Kosten volgende uitbreiding',
      maxLockerItems: 'Max. kluisitems',
      depositedMsg: '{amount} goud gestort bij bank',
      withdrewMsg: '{amount} goud opgenomen bij bank',
    },
    shop: {
      title: 'Winkel',
      tabBuy: 'Kopen',
      tabSell: 'Verkopen',
      tabCraft: 'Maken',
      buyPrice: 'Koopprijs',
      sellPrice: 'Verkoopprijs',
      youHave: 'U heeft',
      buyAction: 'Kopen',
      buyAgainAction: 'Meer kopen',
      sellAction: 'Verkopen',
      sellAllAction: 'Alles verkopen',
      craftAction: 'Maken',
      buyEmpty: 'Deze winkel heeft geen items te koop.',
      sellEmpty: 'U heeft geen items die deze winkel kan kopen.',
      craftEmpty: 'Deze winkel heeft geen maakopties.',
      ingredients: 'Ingrediënten',
      noIngredients: 'Geen ingrediënten vereist.',
      boughtMsg: '{amount}x {name} gekocht',
      soldMsg: '{amount}x {name} verkocht',
      craftedMsg: '{name} gemaakt',
    },
    trade: {
      title: 'Ruilen',
      addItem: 'Item toevoegen',
      yourItems: 'Uw items',
      partnerItems: 'Items van {name}',
      agreed: 'Akkoord',
      notAgreed: 'Niet akkoord',
      scamWarning: 'WAARSCHUWING: Items zijn gewijzigd!',
      searchPlaceholder: 'Items zoeken...',
      dropHowMany: 'Hoeveel wil je ruilen?',
      partnerNoItems: '{name} heeft geen items aangeboden.',
      yourNoItems: 'U heeft geen items aangeboden.',
      drop: 'Ruilen',
      agree: 'Akkoord',
      btnUnagree: 'Akkoord intrekken',
    },
    skillMaster: {
      learnTab: 'Leren',
      forgetTab: 'Vergeten',
      learnBtn: 'Leren',
      forgetBtn: 'Vergeten',
      resetBtn: 'Personage resetten',
      noSkillsToLearn: 'Er zijn geen vaardigheden beschikbaar om te leren.',
      noSkillsLearned: 'U heeft nog geen vaardigheden geleerd.',
      cost: 'Kosten',
      levelReq: 'Niveau',
      classReq: 'Klasse',
      statStr: 'STR',
      statIntl: 'INT',
      statWis: 'WIS',
      statAgi: 'BEH',
      statCon: 'CON',
      statCha: 'KAR',
      gold: 'goud',
      skillReq: 'Vereist',
      learnedMsg: '{name} geleerd',
      forgotMsg: '{name} vergeten',
      resetMsg: 'Personage is gereset',
    },
    spells: {
      title: 'Spreuken',
      comingSoon: 'Spreuken komen binnenkort',
      noSpells: 'Nog geen spreuken geleerd',
      skillPoints: 'Vaardigheidspunten: {count}',
      level: 'Nv {level}',
      trainBtn: 'Trainen',
      dragHint: 'Sleep naar actiebalk',
      trainedMsg: '{name} getraind tot niveau {level}',
    },
    quests: {
      title: 'Quests',
      comingSoon: 'Quests komen binnenkort',
      tabActive: 'Actief',
      tabHistory: 'Geschiedenis',
      track: 'Volgen',
      noActive: 'Geen actieve quests',
      noHistory: 'Geen voltooide quests',
      trackerTitle: 'Quest-tracker',
      npcOk: 'OK',
      npcSwitch: 'Quest wisselen',
    },
    party: {
      panelTitle: 'Groep',
      panelLeave: 'Groep verlaten',
      panelKick: 'Uit groep verwijderen',
      leader: 'Leider',
    },
    social: {
      title: 'Sociaal',
      whisper: 'Fluisteren',
      removeFriend: 'Vriend verwijderen',
      addFriend: 'Vriend toevoegen',
      unignore: 'Deblokkeren',
      ignore: 'Blokkeren',
      online: 'Online ({count})',
      friends: 'Vrienden ({count})',
      guild: 'Gilde ({count})',
      ignored: 'Geblokkeerd ({count})',
    },
    jukebox: {
      noSongs: 'Geen nummers beschikbaar',
      nowPlaying: 'Nu speelt: {track}',
    },
    bard: {
      title: 'Bardvaardigheid',
      noInstrument:
        'Je hebt een instrument nodig om bardenvaardigheden te gebruiken.',
    },
    barber: {
      title: 'Kapper',
      hairStyle: 'Haarstijl',
      hairColor: 'Haarkleur',
      showHat: 'Hoed tonen',
      cost: 'Kosten',
      buy: 'Kopen',
      bald: 'Kaal',
      confirmTitle: 'Kapsel wijzigen',
      confirmMessage: 'Weet je zeker dat je je kapsel wilt wijzigen?',
    },
    innKeeper: {
      title: 'Herberg',
      becomeCitizen: 'Burger worden',
      giveUpCitizenship: 'Burgerschap opgeven',
      sleep: 'Slapen',
      becameCitizenMsg: 'U bent nu een burger!',
      wrongAnswersMsg: 'Sommige antwoorden waren fout. Probeer opnieuw.',
      gaveUpCitizenshipMsg: 'U heeft uw burgerschap opgegeven.',
      notCitizenMsg: 'U bent hier geen burger.',
      sleptMsg: 'U voelt u goed uitgerust.',
      confirmGiveUpTitle: 'Burgerschap opgeven',
      confirmGiveUpMsg: 'Weet je zeker dat je je burgerschap wilt opgeven?',
    },
    law: {
      title: 'Advocaat',
    },
    board: {
      title: 'Stadsmededelingenbord',
      newPost: 'Nieuw bericht',
      postSubject: 'Onderwerp',
      postBody: 'Inhoud',
      postSubmit: 'Plaatsen',
      postCancel: 'Annuleren',
      postBack: 'Terug',
      deletePost: 'Verwijderen',
      noPosts: 'Nog geen berichten.',
      postBy: 'door {author}',
      deleteConfirmTitle: 'Bericht verwijderen',
      deleteConfirmMsg: 'Weet je zeker dat je dit bericht wilt verwijderen?',
    },
    guild: {
      title: 'Gilde',
      tabRegistration: 'Registratie',
      tabCreate: 'Aanmaken',
      tabManagement: 'Beheer',
      tabLookup: 'Opzoeken',
      createTitle: 'Gilde aanmaken',
      createTag: 'Tag (3 tekens)',
      createName: 'Naam',
      createDescription: 'Beschrijving',
      createSubmit: 'Aanmaken starten',
      joinTitle: 'Gilde aansluiten',
      joinTag: 'Gildetag',
      joinRecruiter: 'Naam recruiter',
      joinSubmit: 'Aanvraag indienen',
      currentGuild: 'Huidig gilde',
      leave: 'Gilde verlaten',
      disband: 'Gilde ontbinden',
      leaveConfirmTitle: 'Gilde verlaten',
      leaveConfirmMessage: 'Weet je zeker dat je je gilde wilt verlaten?',
      disbandConfirmTitle: 'Gilde ontbinden',
      disbandConfirmMessage:
        'Weet je zeker dat je het gilde wilt ontbinden? Dit kan niet ongedaan worden gemaakt.',
      creatingTitle: 'Gilde aanmaken in uitvoering',
      creatingWaiting: 'Wachten op acceptatie leden...',
      creatingMembers: 'Geaccepteerde leden',
      manageDescription: 'Beschrijving bewerken',
      manageRanks: 'Rangnamen bewerken',
      manageBank: 'Gildebank',
      manageKick: 'Lid verwijderen',
      manageAssignRank: 'Rang lid wijzigen',
      save: 'Opslaan',
      back: 'Terug',
      bankBalance: 'Banksaldo',
      bankDeposit: 'Storten',
      bankAmount: 'Bedrag',
      kickName: 'Naam lid',
      kickSubmit: 'Verwijderen',
      assignRankName: 'Naam lid',
      assignRankValue: 'Rang (0-9)',
      assignRankSubmit: 'Rang toewijzen',
      rankLabel: 'Rang {n}',
      lookupSearch: 'Tag of naam',
      lookupInfo: 'Gildeinfo',
      lookupMembers: 'Ledenlijst',
      lookupName: 'Naam',
      lookupTag: 'Tag',
      lookupDescription: 'Beschrijving',
      lookupWealth: 'Rijkdom',
      lookupCreated: 'Opgericht',
      lookupStaff: 'Staf',
      lookupRank: 'Rang',
      lookupMember: 'Lid',
      notMember: 'U bent geen lid van een gilde.',
    },
    ping: {
      dialogTitle: 'Ping',
      dialogMin: 'Min',
      dialogMax: 'Max',
      dialogAvg: 'Gem',
      ms: 'ms',
      dialogNoData: 'Wachten op data...',
    },
    cmdPalette: {
      searchPlaceholder: "Commando's zoeken…",
      navigate: 'navigeren',
      run: 'uitvoeren',
      close: 'sluiten',
      noResults: "Geen commando's gevonden",
      recentlyUsed: 'Recent gebruikt',
      results: 'Resultaten',
      all: "Commando's",
    },
    messages: {
      killedNpc: '{killer} heeft {npc} gedood!',
      gainedExp: 'Je hebt {exp} EXP gewonnen!',
      npcDrop: '{item} gevallen!',
      expShare: 'Je hebt {exp} EXP gewonnen via groepsdeling!',
      levelUp: 'Gefeliciteerd! Je hebt niveau {level} bereikt!',
    },
    lang: {
      en: 'English',
      nl: 'Nederlands',
      sv: 'Svenska',
      pt: 'Português',
    },
    nav: {
      inventory: 'Inventaris',
      map: 'Kaart',
      spells: 'Spreuken',
      character: 'Personage',
      quests: 'Quests',
      social: 'Sociaal',
      bot: 'Bot',
      discord: 'Discord',
      settings: 'Instellingen',
      refresh: 'Vernieuwen',
      exit: 'Afsluiten',
    },
  },
  sv: {
    shared: {
      btnOK: 'OK',
      btnCancel: 'Avbryt',
      btnYes: 'Ja',
      btnNo: 'Nej',
      dialogClose: 'Stäng dialog',
      dialogRestore: 'Återställ position',
      wordYou: 'Du',
      wordUnknown: 'Okänd',
      wordGold: 'Guld',
      wordSubmit: 'Skicka',
      wordBack: 'Tillbaka',
      itemFallbackName: 'Föremål {id}',
    },
    mainMenu: {
      inputHost: 'wss://ws.reoserv.net',
      btnCreateAccount: 'Skapa konto',
      btnLogin: 'Logga in',
      btnViewCredits: 'Visa credits',
      logoAlt: 'Endless Online',
    },
    login: {
      title: 'Logga in på ditt konto',
      username: 'Användarnamn',
      password: 'Lösenord',
      remember: 'Kom ihåg mig',
      btnConnect: 'Anslut',
    },
    selectSession: {
      title: 'Välj konto',
      btnPlay: 'Spela',
      btnDelete: 'Ta bort',
      btnLoginDifferent: 'Logga in med annat konto',
      btnBack: 'Tillbaka',
      confirmDeleteTitle: 'Ta bort sparad session',
      confirmDelete: 'Ta bort sparad session för "{0}"?',
      lastLoginJustNow: 'Nyss',
      lastLoginMinutesAgo: '{0}m sedan',
      lastLoginHoursAgo: '{0}h sedan',
      lastLoginDaysAgo: '{0}d sedan',
    },
    createAccount: {
      title: 'Skapa konto',
      username: 'Användarnamn',
      password: 'Lösenord',
      confirmPassword: 'Bekräfta lösenord',
      fullName: 'Fullständigt namn',
      location: 'Plats',
      email: 'E-post',
      btn: 'Skapa konto',
    },
    changePassword: {
      title: 'Byt lösenord',
      username: 'Användarnamn',
      oldPassword: 'Gammalt lösenord',
      newPassword: 'Nytt lösenord',
      confirmPassword: 'Bekräfta nytt lösenord',
      btn: 'Byt lösenord',
    },
    characterSelect: {
      title: 'Välj din karaktär',
      emptySlot: 'Tom plats',
      btnNew: 'Ny karaktär',
      btnLogin: 'Logga in',
      btnDelete: 'Ta bort',
    },
    createCharacter: {
      title: 'Skapa karaktär',
      name: 'Namn',
      gender: 'Kön',
      hairStyle: 'Hårstil',
      hairColor: 'Hårfärg',
      skin: 'Hudton',
      female: 'Kvinna',
      male: 'Man',
      btn: 'Skapa',
    },
    hud: {
      hp: 'HP',
      tp: 'TP',
      tnl: 'TNL',
      weight: 'Vikt',
      lvl: 'Nv',
    },
    character: {
      title: 'Karaktär',
      tabPaperdoll: 'Pappersdocka',
      tabStats: 'Statistik',
      tabBook: 'Bok',
      labelName: 'Namn',
      labelTitle: 'Titel',
      labelHome: 'Hem',
      labelPartner: 'Partner',
      labelGuild: 'Gille',
      labelRank: 'Rang',
      labelClass: 'Klass',
      labelAdmin: 'Admin',
      bookNoQuests: 'Inga avslutade uppdrag',
    },
    stats: {
      labelBase: 'Bas',
      labelDerived: 'Härledd',
      labelStr: 'STY',
      labelInt: 'INT',
      labelWis: 'VIS',
      labelAgi: 'SMI',
      labelCon: 'KON',
      labelCha: 'KAR',
      labelDmg: 'Skada',
      labelAccuracy: 'Träffsäkerhet',
      labelEvade: 'Undvika',
      labelArmor: 'Rustning',
      statPoints: 'Statistikpoäng: {count}',
      trainBtn: '+',
    },
    equipment: {
      hat: 'Hatt',
      necklace: 'Halsband',
      armor: 'Rustning',
      weapon: 'Vapen',
      shield: 'Sköld',
      gloves: 'Handskar',
      belt: 'Bälte',
      boots: 'Stövlar',
      accessory: 'Tillbehör',
      ring1: 'Ring 1',
      ring2: 'Ring 2',
      armlet1: 'Armband 1',
      armlet2: 'Armband 2',
      bracer1: 'Armbågsskydd 1',
      bracer2: 'Armbågsskydd 2',
    },
    admin: {
      badgeSpy: 'SPY',
      badgeLightGuide: 'GUIDE',
      badgeGuardian: 'VAKT',
      badgeGameMaster: 'GM',
      badgeHighGameMaster: 'HGM',
      lightGuide: 'Ljusguide',
      guardian: 'Väktare',
      gameMaster: 'Spelledare',
      highGameMaster: 'Hög GM',
      spy: 'Spion',
    },
    inventory: {
      title: 'Inventarie',
      tab1: 'I',
      tab2: 'II',
      ctxUse: 'Använd',
      ctxDrop: 'Släpp',
      ctxJunk: 'Skräpa',
      ctxAssignSlot: 'Tilldela plats',
      junkConfirmTitle: 'Skräpa föremål',
      junkConfirmMessage: 'Är du säker på att du vill skräpa {name}?',
      junkDropZone: 'Skräpa föremål',
      dropZone: 'Släpp föremål',
    },
    settings: {
      title: 'Inställningar',
      tabGraphics: 'Grafik',
      tabInterface: 'Gränssnitt',
      tabSound: 'Ljud',
      tabSocial: 'Social',
      tabHud: 'HUD',
      tabDebug: 'Felsökning',
      tabAdvanced: 'Avancerat',
      fpsLimit: 'FPS-gräns',
      fpsUnlimited: 'Obegränsad',
      interpolation: 'Bildinterpolering',
      zoom: 'Zoom',
      zoomReset: 'Återställ',
      zoomOut: 'Zooma ut',
      zoomIn: 'Zooma in',
      uiScale: 'UI-skala',
      gameZoom: 'Game Zoom',
      theme: 'Tema',
      language: 'Språk',
      backdropBlur: 'Bakgrundsoskärpa',
      combatNpcGhosting: 'Strids-NPC-ghosting',
      combatNpcGhostingHint:
        'Tillåt gång och klickvägar genom passiva/aggressiva NPC:er.',
      touchReposition: 'Flytta pekskärmskontroller',
      touchRepositionHint:
        'Dra pekskärmskontroller för att flytta dem på skärmen.',
      mobileControls: 'Mobilkontroller',
      mobileJoystick: 'Joystick',
      mobileMovementMode: 'Movement Pad',
      mobileMovementJoystick: 'Joystick',
      mobileMovementDpad: 'D-pad',
      mobileActionButtons: 'Åtgärdsknappar',
      desktopEmoteButton: 'Emote-knapp (skrivbord)',
      visibility_auto: 'Auto',
      visibility_always: 'Alltid',
      visibility_never: 'Aldrig',
      resetPositions: 'Återställ UI-positioner',
      resetPositionsHint:
        'Återställ alla UI-positioner och layoutinställningar till standard.',
      moveUp: 'Flytta upp',
      moveDown: 'Flytta ner',
      masterVolume: 'Huvudvolym',
      effectVolume: 'Effektvolym',
      ambientVolume: 'Omgivningsvolym',
      musicVolume: 'Musikvolym',
      musicForceLoop: 'Loopa alltid musik',
      musicForceLoopHint:
        'Tvingar kartmusik att loopa även om det inte är inställt.',
      whispers: 'Viskar',
      tradeRequests: 'Handelsförfrågningar',
      partyRequests: 'Gruppförfrågningar',
      profanityFilter: 'Svordomar-filter',
      chatLog: 'Chattlogg',
      socialAll: 'Alla',
      socialFriends: 'Vänner',
      socialNone: 'Inga',
      hudPerCharNote: 'Dessa inställningar sparas per karaktär.',
      hudWidget: 'Widget',
      hudVisible: 'Synlig',
      hudPosition: 'Position',
      hudOrder: 'Ordning',
      hudLeft: 'Vänster',
      hudCenter: 'Mitten',
      hudRight: 'Höger',
      hudWidgetCharacter: 'Karaktär',
      hudWidgetHp: 'HP',
      hudWidgetTp: 'TP',
      hudWidgetTnl: 'TNL',
      hudWidgetWeight: 'Vikt',
      hudWidgetPing: 'Ping',
      debugMapLayers: 'Kartlager',
      debugLayerGround: 'Mark',
      debugLayerObjects: 'Objekt',
      debugLayerOverlay: 'Overlay',
      debugLayerDownWall: 'Nedre vägg',
      debugLayerRightWall: 'Höger vägg',
      debugLayerRoof: 'Tak',
      debugLayerTop: 'Topp',
      debugLayerShadow: 'Skugga',
      debugLayerOverlay2: 'Overlay 2',
      debugPacketLog: 'Paketlogg',
      advancedStorage: 'App-lagring',
      advancedLocalStorage: 'Inställningar (localStorage)',
      advancedIndexedDB: 'Cache (IndexedDB)',
      advancedRefresh: 'Uppdatera',
      advancedClearHint:
        'Rensa cachad speldata (kartor, pub-filer, chatthistorik). Dina inställningar bevaras.',
      advancedClearCache: 'Rensa cache',
      advancedClearConfirm:
        'Rensa all cachad speldata? Detta tar bort kartor, pub-filer och chatthistorik. Dina inställningar behålls.',
      advancedCleared: 'Cache rensad.',
    },
    packetLog: {
      title: 'Paketlogg',
      clear: 'Rensa',
      source: 'Källa',
      family: 'Familj',
      action: 'Åtgärd',
      time: 'Tid',
      data: 'Data',
      empty: 'Inga paket fångade än.',
      client: 'Klient',
      server: 'Server',
      sensitive: 'Känslig',
      showSensitive: 'Visa känslig data',
      hideSensitive: 'Dölj känslig data',
      detailTitle: 'Paketdetalj',
      detailClose: 'Stäng',
      detailJson: 'Tolkad',
      detailHex: 'Hex',
      unknownPacket: 'Okänt paket (ingen parser)',
    },
    chat: {
      tapToChat: 'Tryck för att chatta…',
      pressEnterToChat: 'Tryck Enter för att chatta…',
      logAriaLabel: 'Chattlogg',
      openChannelInNewTab: 'Öppna kanal i ny flik',
      readOnly: 'Skrivskyddad kanal',
      saySomething: 'Säg något...',
      sendTo: 'Skicka till {name}...',
      closeTab: 'Stäng {name}',
      noMessages: 'Inga meddelanden ännu.',
    },
    chatLog: {
      title: 'Chattlogg',
      allChannels: 'Alla kanaler',
      local: 'Lokal',
      global: 'Global',
      party: 'Grupp',
      guild: 'Gille',
      admin: 'Admin',
      system: 'System',
      private: 'Privata meddelanden',
      export: 'Exportera',
      plainText: 'Klartext',
      json: 'JSON',
      csv: 'CSV',
      clearAll: 'Rensa allt',
      clearTitle: 'Rensa chattlogg',
      clearMessage:
        'Ta bort alla sparade chattmeddelanden? Detta kan inte ångras.',
      searchPlaceholder: 'Sök namn eller meddelande…',
      sortOldestFirst: 'Äldst först',
      sortNewestFirst: 'Nyast först',
      sortOldest: 'Äldst',
      sortNewest: 'Nyast',
      loading: 'Laddar…',
      noMessages: 'Inga meddelanden hittades.',
      deleteMessage: 'Ta bort meddelande',
      noMessagesShort: 'Inga meddelanden',
      pagination: 'Sida {page} av {totalPages} · {total} totalt',
    },
    chest: {
      title: 'Kista',
      empty: 'Kistan är tom',
      depositHow: 'Hur många vill du deponera?',
      deposit: 'Deponera',
      depositedMsg: 'Lade till {amount}x {name} i kistan',
      tookMsg: 'Tog {amount}x {name} från kistan',
    },
    locker: {
      title: 'Bankfack',
      empty: 'Ditt fack är tomt',
      deposit: 'Deponera',
      withdraw: 'Ta ut',
      searchPlaceholder: 'Sök föremål…',
      filterAll: 'Alla',
      filterWeapon: 'Vapen',
      filterArmor: 'Rustning',
      filterAccessory: 'Tillbehör',
      filterConsumable: 'Förbrukningsvara',
      filterOther: 'Övrigt',
      depositedMsg: 'Deponerade {amount}x {name} i facket',
      tookMsg: 'Tog {amount}x {name} från facket',
      upgradedMsg: 'Facket uppgraderat!',
    },
    bank: {
      title: 'Bank',
      balance: 'Saldo',
      onHand: 'Till hands',
      deposit: 'Deponera',
      withdraw: 'Ta ut',
      lockerUpgrades: 'Fackuppgraderingar',
      buyUpgrade: 'Köp uppgradering',
      nextUpgradeCost: 'Nästa uppgraderingskostnad',
      maxLockerItems: 'Max fackföremål',
      depositedMsg: 'Deponerade {amount} guld till banken',
      withdrewMsg: 'Tog ut {amount} guld från banken',
    },
    shop: {
      title: 'Butik',
      tabBuy: 'Köp',
      tabSell: 'Sälj',
      tabCraft: 'Tillverka',
      buyPrice: 'Köppris',
      sellPrice: 'Säljpris',
      youHave: 'Du har',
      buyAction: 'Köp',
      buyAgainAction: 'Köp mer',
      sellAction: 'Sälj',
      sellAllAction: 'Sälj allt',
      craftAction: 'Tillverka',
      buyEmpty: 'Den här butiken har inga varor att köpa.',
      sellEmpty: 'Du har inga varor som den här butiken kan köpa.',
      craftEmpty: 'Den här butiken har inga tillverkningsrecept.',
      ingredients: 'Ingredienser',
      noIngredients: 'Inga ingredienser krävs.',
      boughtMsg: 'Köpte {amount}x {name}',
      soldMsg: 'Sålde {amount}x {name}',
      craftedMsg: 'Tillverkade {name}',
    },
    trade: {
      title: 'Byta',
      addItem: 'Lägg till föremål',
      yourItems: 'Dina föremål',
      partnerItems: '{name}s föremål',
      agreed: 'Överens',
      notAgreed: 'Inte överens',
      scamWarning: 'VARNING: Föremål har ändrats!',
      searchPlaceholder: 'Sök föremål...',
      dropHowMany: 'Hur många vill du byta?',
      partnerNoItems: '{name} har inte erbjudit några föremål.',
      yourNoItems: 'Du har inte erbjudit några föremål.',
      drop: 'Byta',
      agree: 'Godkänn',
      btnUnagree: 'Ångra godkännande',
    },
    skillMaster: {
      learnTab: 'Lär',
      forgetTab: 'Glöm',
      learnBtn: 'Lär',
      forgetBtn: 'Glöm',
      resetBtn: 'Återställ karaktär',
      noSkillsToLearn: 'Det finns inga färdigheter att lära sig.',
      noSkillsLearned: 'Du har inte lärt dig några färdigheter.',
      cost: 'Kostnad',
      levelReq: 'Nivå',
      classReq: 'Klass',
      statStr: 'STY',
      statIntl: 'INT',
      statWis: 'VIS',
      statAgi: 'SMI',
      statCon: 'KON',
      statCha: 'KAR',
      gold: 'guld',
      skillReq: 'Kräver',
      learnedMsg: 'Lärde {name}',
      forgotMsg: 'Glömde {name}',
      resetMsg: 'Karaktären har återställts',
    },
    spells: {
      title: 'Besvärjelser',
      comingSoon: 'Besvärjelser kommer snart',
      noSpells: 'Inga besvärjelser inlärda än',
      skillPoints: 'Färdighetspoäng: {count}',
      level: 'Nv {level}',
      trainBtn: 'Träna',
      dragHint: 'Dra till aktionsfältet',
      trainedMsg: '{name} tränad till nivå {level}',
    },
    quests: {
      title: 'Uppdrag',
      comingSoon: 'Uppdrag kommer snart',
      tabActive: 'Aktiva',
      tabHistory: 'Historik',
      track: 'Spåra',
      noActive: 'Inga aktiva uppdrag',
      noHistory: 'Inga avslutade uppdrag',
      trackerTitle: 'Uppdragsspårare',
      npcOk: 'OK',
      npcSwitch: 'Byt uppdrag',
    },
    party: {
      panelTitle: 'Grupp',
      panelLeave: 'Lämna grupp',
      panelKick: 'Kicka från grupp',
      leader: 'Ledare',
    },
    social: {
      title: 'Social',
      whisper: 'Viska',
      removeFriend: 'Ta bort vän',
      addFriend: 'Lägg till vän',
      unignore: 'Avblockera',
      ignore: 'Blockera',
      online: 'Online ({count})',
      friends: 'Vänner ({count})',
      guild: 'Gille ({count})',
      ignored: 'Blockerade ({count})',
    },
    jukebox: {
      noSongs: 'Inga låtar tillgängliga',
      nowPlaying: 'Spelar nu: {track}',
    },
    bard: {
      title: 'Bardfärdighet',
      noInstrument:
        'Du måste ha ett instrument utrustat för att använda bardfärdigheter.',
    },
    barber: {
      title: 'Frisör',
      hairStyle: 'Hårstil',
      hairColor: 'Hårfärg',
      showHat: 'Visa hatt',
      cost: 'Kostnad',
      buy: 'Köp',
      bald: 'Skallig',
      confirmTitle: 'Byt frisyr',
      confirmMessage: 'Är du säker på att du vill byta frisyr?',
    },
    innKeeper: {
      title: 'Värdshus',
      becomeCitizen: 'Bli medborgare',
      giveUpCitizenship: 'Ge upp medborgarskap',
      sleep: 'Sov',
      becameCitizenMsg: 'Du är nu medborgare!',
      wrongAnswersMsg: 'Några svar var fel. Försök igen.',
      gaveUpCitizenshipMsg: 'Du har gett upp ditt medborgarskap.',
      notCitizenMsg: 'Du är inte medborgare här.',
      sleptMsg: 'Du känner dig väl utvilad.',
      confirmGiveUpTitle: 'Ge upp medborgarskap',
      confirmGiveUpMsg: 'Är du säker på att du vill ge upp ditt medborgarskap?',
    },
    law: {
      title: 'Advokat',
    },
    board: {
      title: 'Stadsstyrelsen',
      newPost: 'Nytt inlägg',
      postSubject: 'Ämne',
      postBody: 'Innehåll',
      postSubmit: 'Publicera',
      postCancel: 'Avbryt',
      postBack: 'Tillbaka',
      deletePost: 'Ta bort',
      noPosts: 'Inga inlägg än.',
      postBy: 'av {author}',
      deleteConfirmTitle: 'Ta bort inlägg',
      deleteConfirmMsg: 'Är du säker på att du vill ta bort det här inlägget?',
    },
    guild: {
      title: 'Gille',
      tabRegistration: 'Registrering',
      tabCreate: 'Skapa',
      tabManagement: 'Hantering',
      tabLookup: 'Sök',
      createTitle: 'Skapa gille',
      createTag: 'Tagg (3 tecken)',
      createName: 'Namn',
      createDescription: 'Beskrivning',
      createSubmit: 'Påbörja skapande',
      joinTitle: 'Gå med i gille',
      joinTag: 'Gilletagg',
      joinRecruiter: 'Rekryterarens namn',
      joinSubmit: 'Begär att gå med',
      currentGuild: 'Nuvarande gille',
      leave: 'Lämna gille',
      disband: 'Upplös gille',
      leaveConfirmTitle: 'Lämna gille',
      leaveConfirmMessage: 'Är du säker på att du vill lämna ditt gille?',
      disbandConfirmTitle: 'Upplös gille',
      disbandConfirmMessage:
        'Är du säker på att du vill upplösa gildet? Detta kan inte ångras.',
      creatingTitle: 'Gilleskapande pågår',
      creatingWaiting: 'Väntar på att medlemmar ska acceptera...',
      creatingMembers: 'Accepterade medlemmar',
      manageDescription: 'Redigera beskrivning',
      manageRanks: 'Redigera rangnamn',
      manageBank: 'Gillebank',
      manageKick: 'Kicka medlem',
      manageAssignRank: 'Ändra medlemsrang',
      save: 'Spara',
      back: 'Tillbaka',
      bankBalance: 'Banksaldo',
      bankDeposit: 'Deponera',
      bankAmount: 'Belopp',
      kickName: 'Medlemsnamn',
      kickSubmit: 'Kicka',
      assignRankName: 'Medlemsnamn',
      assignRankValue: 'Rang (0-9)',
      assignRankSubmit: 'Tilldela rang',
      rankLabel: 'Rang {n}',
      lookupSearch: 'Tagg eller namn',
      lookupInfo: 'Gilleinformation',
      lookupMembers: 'Medlemslista',
      lookupName: 'Namn',
      lookupTag: 'Tagg',
      lookupDescription: 'Beskrivning',
      lookupWealth: 'Förmögenhet',
      lookupCreated: 'Grundat',
      lookupStaff: 'Personal',
      lookupRank: 'Rang',
      lookupMember: 'Medlem',
      notMember: 'Du är inte med i något gille.',
    },
    ping: {
      dialogTitle: 'Ping',
      dialogMin: 'Min',
      dialogMax: 'Max',
      dialogAvg: 'Medel',
      ms: 'ms',
      dialogNoData: 'Väntar på data...',
    },
    cmdPalette: {
      searchPlaceholder: 'Sök kommandon…',
      navigate: 'navigera',
      run: 'kör',
      close: 'stäng',
      noResults: 'Inga kommandon hittades',
      recentlyUsed: 'Nyligen använt',
      results: 'Resultat',
      all: 'Kommandon',
    },
    messages: {
      killedNpc: '{killer} dödade {npc}!',
      gainedExp: 'Du fick {exp} EXP!',
      npcDrop: '{item} föll!',
      expShare: 'Du fick {exp} EXP från gruppdelning!',
      levelUp: 'Grattis! Du nådde nivå {level}!',
    },
    lang: {
      en: 'English',
      nl: 'Nederlands',
      sv: 'Svenska',
      pt: 'Português',
    },
    nav: {
      inventory: 'Inventarie',
      map: 'Karta',
      spells: 'Besvärjelser',
      character: 'Karaktär',
      quests: 'Uppdrag',
      social: 'Social',
      bot: 'Bot',
      discord: 'Discord',
      settings: 'Inställningar',
      refresh: 'Uppdatera',
      exit: 'Avsluta',
    },
  },
  pt: {
    shared: {
      btnOK: 'OK',
      btnCancel: 'Cancelar',
      btnYes: 'Sim',
      btnNo: 'Não',
      dialogClose: 'Fechar diálogo',
      dialogRestore: 'Restaurar posição',
      wordYou: 'Você',
      wordUnknown: 'Desconhecido',
      wordGold: 'Ouro',
      wordSubmit: 'Enviar',
      wordBack: 'Voltar',
      itemFallbackName: 'Item {id}',
    },
    mainMenu: {
      inputHost: 'wss://ws.reoserv.net',
      btnCreateAccount: 'Criar Conta',
      btnLogin: 'Entrar',
      btnViewCredits: 'Ver Créditos',
      logoAlt: 'Endless Online',
    },
    login: {
      title: 'Entrar na Sua Conta',
      username: 'Nome de usuário',
      password: 'Senha',
      remember: 'Lembrar de mim',
      btnConnect: 'Conectar',
    },
    selectSession: {
      title: 'Selecionar Conta',
      btnPlay: 'Jogar',
      btnDelete: 'Excluir',
      btnLoginDifferent: 'Entrar com outra conta',
      btnBack: 'Voltar',
      confirmDeleteTitle: 'Excluir sessão salva',
      confirmDelete: 'Remover sessão salva de "{0}"?',
      lastLoginJustNow: 'Agora mesmo',
      lastLoginMinutesAgo: '{0}min atrás',
      lastLoginHoursAgo: '{0}h atrás',
      lastLoginDaysAgo: '{0}d atrás',
    },
    createAccount: {
      title: 'Criar Conta',
      username: 'Nome de usuário',
      password: 'Senha',
      confirmPassword: 'Confirmar senha',
      fullName: 'Nome completo',
      location: 'Localização',
      email: 'E-mail',
      btn: 'Criar Conta',
    },
    changePassword: {
      title: 'Alterar Senha',
      username: 'Nome de usuário',
      oldPassword: 'Senha antiga',
      newPassword: 'Nova senha',
      confirmPassword: 'Confirmar nova senha',
      btn: 'Alterar Senha',
    },
    characterSelect: {
      title: 'Selecione Seu Personagem',
      emptySlot: 'Slot Vazio',
      btnNew: 'Novo Personagem',
      btnLogin: 'Entrar',
      btnDelete: 'Excluir',
    },
    createCharacter: {
      title: 'Criar Personagem',
      name: 'Nome',
      gender: 'Gênero',
      hairStyle: 'Estilo de Cabelo',
      hairColor: 'Cor do Cabelo',
      skin: 'Tom de Pele',
      female: 'Feminino',
      male: 'Masculino',
      btn: 'Criar',
    },
    hud: {
      hp: 'HP',
      tp: 'TP',
      tnl: 'TNL',
      weight: 'Peso',
      lvl: 'Nv',
    },
    character: {
      title: 'Personagem',
      tabPaperdoll: 'Boneco de Papel',
      tabStats: 'Atributos',
      tabBook: 'Livro',
      labelName: 'Nome',
      labelTitle: 'Título',
      labelHome: 'Lar',
      labelPartner: 'Parceiro',
      labelGuild: 'Guilda',
      labelRank: 'Posto',
      labelClass: 'Classe',
      labelAdmin: 'Admin',
      bookNoQuests: 'Nenhuma missão concluída',
    },
    stats: {
      labelBase: 'Base',
      labelDerived: 'Derivado',
      labelStr: 'FOR',
      labelInt: 'INT',
      labelWis: 'SAB',
      labelAgi: 'AGI',
      labelCon: 'CON',
      labelCha: 'CAR',
      labelDmg: 'Dano',
      labelAccuracy: 'Precisão',
      labelEvade: 'Esquiva',
      labelArmor: 'Armadura',
      statPoints: 'Pontos de Atributo: {count}',
      trainBtn: '+',
    },
    equipment: {
      hat: 'Chapéu',
      necklace: 'Colar',
      armor: 'Armadura',
      weapon: 'Arma',
      shield: 'Escudo',
      gloves: 'Luvas',
      belt: 'Cinto',
      boots: 'Botas',
      accessory: 'Acessório',
      ring1: 'Anel 1',
      ring2: 'Anel 2',
      armlet1: 'Bracelete 1',
      armlet2: 'Bracelete 2',
      bracer1: 'Protetor de Braço 1',
      bracer2: 'Protetor de Braço 2',
    },
    admin: {
      badgeSpy: 'SPY',
      badgeLightGuide: 'GUIA',
      badgeGuardian: 'GUARD',
      badgeGameMaster: 'GM',
      badgeHighGameMaster: 'HGM',
      lightGuide: 'Guia da Luz',
      guardian: 'Guardião',
      gameMaster: 'Mestre do Jogo',
      highGameMaster: 'Alto GM',
      spy: 'Espião',
    },
    inventory: {
      title: 'Inventário',
      tab1: 'I',
      tab2: 'II',
      ctxUse: 'Usar',
      ctxDrop: 'Jogar fora',
      ctxJunk: 'Descartar',
      ctxAssignSlot: 'Atribuir Slot',
      junkConfirmTitle: 'Descartar Item',
      junkConfirmMessage: 'Tem certeza que deseja descartar {name}?',
      junkDropZone: 'Descartar Item',
      dropZone: 'Jogar fora Item',
    },
    settings: {
      title: 'Configurações',
      tabGraphics: 'Gráficos',
      tabInterface: 'Interface',
      tabSound: 'Som',
      tabSocial: 'Social',
      tabHud: 'HUD',
      tabDebug: 'Depuração',
      tabAdvanced: 'Avançado',
      fpsLimit: 'Limite de FPS',
      fpsUnlimited: 'Ilimitado',
      interpolation: 'Interpolação de Quadros',
      zoom: 'Zoom',
      zoomReset: 'Redefinir',
      zoomOut: 'Diminuir zoom',
      zoomIn: 'Aumentar zoom',
      uiScale: 'Escala da Interface',
      gameZoom: 'Game Zoom',
      theme: 'Tema',
      language: 'Idioma',
      backdropBlur: 'Desfoque de Fundo',
      combatNpcGhosting: 'Ghosting de NPCs de Combate',
      combatNpcGhostingHint:
        'Permite andar e criar rotas por NPCs passivos/agressivos.',
      touchReposition: 'Reposicionar Controles de Toque',
      touchRepositionHint:
        'Arraste os controles de toque para reposicioná-los na tela.',
      mobileControls: 'Controles Móveis',
      mobileJoystick: 'Joystick',
      mobileMovementMode: 'Movement Pad',
      mobileMovementJoystick: 'Joystick',
      mobileMovementDpad: 'D-pad',
      mobileActionButtons: 'Botões de Ação',
      desktopEmoteButton: 'Botão de Emote (Desktop)',
      visibility_auto: 'Auto',
      visibility_always: 'Sempre',
      visibility_never: 'Nunca',
      resetPositions: 'Redefinir Posições da Interface',
      resetPositionsHint:
        'Redefinir todas as posições e configurações de layout da interface para os padrões.',
      moveUp: 'Mover para cima',
      moveDown: 'Mover para baixo',
      masterVolume: 'Volume Principal',
      effectVolume: 'Volume de Efeitos',
      ambientVolume: 'Volume Ambiente',
      musicVolume: 'Volume da Música',
      musicForceLoop: 'Sempre Repetir Música',
      musicForceLoopHint:
        'Força as músicas do mapa a repetirem mesmo quando não estão configuradas para isso.',
      whispers: 'Sussurros',
      tradeRequests: 'Pedidos de Troca',
      partyRequests: 'Pedidos de Grupo',
      profanityFilter: 'Filtro de Palavrões',
      chatLog: 'Registro de Chat',
      socialAll: 'Todos',
      socialFriends: 'Amigos',
      socialNone: 'Nenhum',
      hudPerCharNote: 'Estas configurações são salvas por personagem.',
      hudWidget: 'Widget',
      hudVisible: 'Visível',
      hudPosition: 'Posição',
      hudOrder: 'Ordem',
      hudLeft: 'Esquerda',
      hudCenter: 'Centro',
      hudRight: 'Direita',
      hudWidgetCharacter: 'Personagem',
      hudWidgetHp: 'HP',
      hudWidgetTp: 'TP',
      hudWidgetTnl: 'TNL',
      hudWidgetWeight: 'Peso',
      hudWidgetPing: 'Ping',
      debugMapLayers: 'Camadas do Mapa',
      debugLayerGround: 'Chão',
      debugLayerObjects: 'Objetos',
      debugLayerOverlay: 'Sobreposição',
      debugLayerDownWall: 'Parede Inferior',
      debugLayerRightWall: 'Parede Direita',
      debugLayerRoof: 'Telhado',
      debugLayerTop: 'Topo',
      debugLayerShadow: 'Sombra',
      debugLayerOverlay2: 'Sobreposição 2',
      debugPacketLog: 'Registro de Pacotes',
      advancedStorage: 'Armazenamento do App',
      advancedLocalStorage: 'Configurações (localStorage)',
      advancedIndexedDB: 'Cache (IndexedDB)',
      advancedRefresh: 'Atualizar',
      advancedClearHint:
        'Limpar dados em cache do jogo (mapas, arquivos pub, histórico de chat). Suas configurações são preservadas.',
      advancedClearCache: 'Limpar Cache',
      advancedClearConfirm:
        'Limpar todos os dados em cache do jogo? Isso excluirá mapas, arquivos pub e histórico de chat. Suas configurações serão mantidas.',
      advancedCleared: 'Cache limpo com sucesso.',
    },
    packetLog: {
      title: 'Registro de Pacotes',
      clear: 'Limpar',
      source: 'Fonte',
      family: 'Família',
      action: 'Ação',
      time: 'Tempo',
      data: 'Dados',
      empty: 'Nenhum pacote capturado ainda.',
      client: 'Cliente',
      server: 'Servidor',
      sensitive: 'Sensível',
      showSensitive: 'Mostrar dados sensíveis',
      hideSensitive: 'Ocultar dados sensíveis',
      detailTitle: 'Detalhe do Pacote',
      detailClose: 'Fechar',
      detailJson: 'Analisado',
      detailHex: 'Hex',
      unknownPacket: 'Pacote desconhecido (sem parser)',
    },
    chat: {
      tapToChat: 'Toque para conversar…',
      pressEnterToChat: 'Pressione Enter para conversar…',
      logAriaLabel: 'Registro de chat',
      openChannelInNewTab: 'Abrir canal em nova aba',
      readOnly: 'Canal somente leitura',
      saySomething: 'Diga algo...',
      sendTo: 'Enviar para {name}...',
      closeTab: 'Fechar {name}',
      noMessages: 'Nenhuma mensagem ainda.',
    },
    chatLog: {
      title: 'Registro de Chat',
      allChannels: 'Todos os Canais',
      local: 'Local',
      global: 'Global',
      party: 'Grupo',
      guild: 'Guilda',
      admin: 'Admin',
      system: 'Sistema',
      private: 'Mensagens Privadas',
      export: 'Exportar',
      plainText: 'Texto Simples',
      json: 'JSON',
      csv: 'CSV',
      clearAll: 'Limpar Tudo',
      clearTitle: 'Limpar Registro de Chat',
      clearMessage:
        'Excluir todas as mensagens de chat salvas? Isso não pode ser desfeito.',
      searchPlaceholder: 'Pesquisar nome ou mensagem…',
      sortOldestFirst: 'Mais antigo primeiro',
      sortNewestFirst: 'Mais recente primeiro',
      sortOldest: 'Mais antigo',
      sortNewest: 'Mais recente',
      loading: 'Carregando…',
      noMessages: 'Nenhuma mensagem encontrada.',
      deleteMessage: 'Excluir mensagem',
      noMessagesShort: 'Sem mensagens',
      pagination: 'Página {page} de {totalPages} · {total} total',
    },
    chest: {
      title: 'Baú',
      empty: 'O baú está vazio',
      depositHow: 'Quantos deseja depositar?',
      deposit: 'Depositar',
      depositedMsg: 'Adicionou {amount}x {name} ao baú',
      tookMsg: 'Pegou {amount}x {name} do baú',
    },
    locker: {
      title: 'Cofre do Banco',
      empty: 'Seu cofre está vazio',
      deposit: 'Depositar',
      withdraw: 'Retirar',
      searchPlaceholder: 'Pesquisar itens…',
      filterAll: 'Todos',
      filterWeapon: 'Arma',
      filterArmor: 'Armadura',
      filterAccessory: 'Acessório',
      filterConsumable: 'Consumível',
      filterOther: 'Outro',
      depositedMsg: 'Depositou {amount}x {name} no cofre',
      tookMsg: 'Pegou {amount}x {name} do cofre',
      upgradedMsg: 'Cofre melhorado!',
    },
    bank: {
      title: 'Banco',
      balance: 'Saldo',
      onHand: 'Em mãos',
      deposit: 'Depositar',
      withdraw: 'Retirar',
      lockerUpgrades: 'Melhorias do Cofre',
      buyUpgrade: 'Comprar melhoria',
      nextUpgradeCost: 'Custo da próxima melhoria',
      maxLockerItems: 'Máximo de itens no cofre',
      depositedMsg: 'Depositou {amount} de ouro no banco',
      withdrewMsg: 'Retirou {amount} de ouro do banco',
    },
    shop: {
      title: 'Loja',
      tabBuy: 'Comprar',
      tabSell: 'Vender',
      tabCraft: 'Fabricar',
      buyPrice: 'Preço de compra',
      sellPrice: 'Preço de venda',
      youHave: 'Você tem',
      buyAction: 'Comprar',
      buyAgainAction: 'Comprar Mais',
      sellAction: 'Vender',
      sellAllAction: 'Vender Tudo',
      craftAction: 'Fabricar',
      buyEmpty: 'Esta loja não tem itens para comprar.',
      sellEmpty: 'Você não tem itens que esta loja possa comprar.',
      craftEmpty: 'Esta loja não tem receitas de fabricação.',
      ingredients: 'Ingredientes',
      noIngredients: 'Nenhum ingrediente necessário.',
      boughtMsg: 'Comprou {amount}x {name}',
      soldMsg: 'Vendeu {amount}x {name}',
      craftedMsg: 'Fabricou {name}',
    },
    trade: {
      title: 'Troca',
      addItem: 'Adicionar Item',
      yourItems: 'Seus Itens',
      partnerItems: 'Itens de {name}',
      agreed: 'Aceito',
      notAgreed: 'Não Aceito',
      scamWarning: 'AVISO: Os itens foram alterados!',
      searchPlaceholder: 'Pesquisar itens...',
      dropHowMany: 'Quantos deseja trocar?',
      partnerNoItems: '{name} não ofereceu nenhum item.',
      yourNoItems: 'Você não ofereceu nenhum item.',
      drop: 'Trocar',
      agree: 'Aceitar',
      btnUnagree: 'Cancelar Aceite',
    },
    skillMaster: {
      learnTab: 'Aprender',
      forgetTab: 'Esquecer',
      learnBtn: 'Aprender',
      forgetBtn: 'Esquecer',
      resetBtn: 'Redefinir Personagem',
      noSkillsToLearn: 'Não há habilidades disponíveis para aprender.',
      noSkillsLearned: 'Você não aprendeu nenhuma habilidade.',
      cost: 'Custo',
      levelReq: 'Nível',
      classReq: 'Classe',
      statStr: 'FOR',
      statIntl: 'INT',
      statWis: 'SAB',
      statAgi: 'AGI',
      statCon: 'CON',
      statCha: 'CAR',
      gold: 'ouro',
      skillReq: 'Requer',
      learnedMsg: 'Aprendeu {name}',
      forgotMsg: 'Esqueceu {name}',
      resetMsg: 'Personagem foi redefinido',
    },
    spells: {
      title: 'Feitiços',
      comingSoon: 'Feitiços em breve',
      noSpells: 'Nenhum feitiço aprendido ainda',
      skillPoints: 'Pontos de Habilidade: {count}',
      level: 'Nv {level}',
      trainBtn: 'Treinar',
      dragHint: 'Arraste para a barra de ações',
      trainedMsg: '{name} treinado ao nível {level}',
    },
    quests: {
      title: 'Missões',
      comingSoon: 'Missões em breve',
      tabActive: 'Ativas',
      tabHistory: 'Histórico',
      track: 'Rastrear',
      noActive: 'Nenhuma missão ativa',
      noHistory: 'Nenhuma missão concluída',
      trackerTitle: 'Rastreador de Missões',
      npcOk: 'OK',
      npcSwitch: 'Trocar Missão',
    },
    party: {
      panelTitle: 'Grupo',
      panelLeave: 'Sair do grupo',
      panelKick: 'Expulsar do grupo',
      leader: 'Líder',
    },
    social: {
      title: 'Social',
      whisper: 'Sussurrar',
      removeFriend: 'Remover Amigo',
      addFriend: 'Adicionar Amigo',
      unignore: 'Desbloquear',
      ignore: 'Bloquear',
      online: 'Online ({count})',
      friends: 'Amigos ({count})',
      guild: 'Guilda ({count})',
      ignored: 'Bloqueados ({count})',
    },
    jukebox: {
      noSongs: 'Nenhuma música disponível',
      nowPlaying: 'Tocando agora: {track}',
    },
    bard: {
      title: 'Habilidade de Bardo',
      noInstrument:
        'Você precisa de um instrumento equipado para usar habilidades de bardo.',
    },
    barber: {
      title: 'Barbeiro',
      hairStyle: 'Estilo de Cabelo',
      hairColor: 'Cor do Cabelo',
      showHat: 'Mostrar Chapéu',
      cost: 'Custo',
      buy: 'Comprar',
      bald: 'Careca',
      confirmTitle: 'Alterar Penteado',
      confirmMessage: 'Tem certeza que deseja alterar seu penteado?',
    },
    innKeeper: {
      title: 'Estalagem',
      becomeCitizen: 'Tornar-se Cidadão',
      giveUpCitizenship: 'Abrir Mão da Cidadania',
      sleep: 'Dormir',
      becameCitizenMsg: 'Você agora é um cidadão!',
      wrongAnswersMsg: 'Algumas respostas estavam erradas. Tente novamente.',
      gaveUpCitizenshipMsg: 'Você abriu mão da sua cidadania.',
      notCitizenMsg: 'Você não é cidadão aqui.',
      sleptMsg: 'Você se sente bem descansado.',
      confirmGiveUpTitle: 'Abrir Mão da Cidadania',
      confirmGiveUpMsg: 'Tem certeza que deseja abrir mão da sua cidadania?',
    },
    law: {
      title: 'Advogado',
    },
    board: {
      title: 'Quadro da Cidade',
      newPost: 'Nova Publicação',
      postSubject: 'Assunto',
      postBody: 'Corpo',
      postSubmit: 'Publicar',
      postCancel: 'Cancelar',
      postBack: 'Voltar',
      deletePost: 'Excluir',
      noPosts: 'Nenhuma publicação ainda.',
      postBy: 'por {author}',
      deleteConfirmTitle: 'Excluir Publicação',
      deleteConfirmMsg: 'Tem certeza que deseja excluir esta publicação?',
    },
    guild: {
      title: 'Guilda',
      tabRegistration: 'Registro',
      tabCreate: 'Criar',
      tabManagement: 'Gerenciamento',
      tabLookup: 'Pesquisar',
      createTitle: 'Criar Guilda',
      createTag: 'Tag (3 caracteres)',
      createName: 'Nome',
      createDescription: 'Descrição',
      createSubmit: 'Iniciar Criação',
      joinTitle: 'Entrar em Guilda',
      joinTag: 'Tag da Guilda',
      joinRecruiter: 'Nome do Recrutador',
      joinSubmit: 'Solicitar Entrada',
      currentGuild: 'Guilda Atual',
      leave: 'Sair da Guilda',
      disband: 'Dissolver Guilda',
      leaveConfirmTitle: 'Sair da Guilda',
      leaveConfirmMessage: 'Tem certeza que deseja sair da sua guilda?',
      disbandConfirmTitle: 'Dissolver Guilda',
      disbandConfirmMessage:
        'Tem certeza que deseja dissolver a guilda? Isso não pode ser desfeito.',
      creatingTitle: 'Criação de Guilda em Andamento',
      creatingWaiting: 'Aguardando membros aceitarem...',
      creatingMembers: 'Membros Aceitos',
      manageDescription: 'Editar Descrição',
      manageRanks: 'Editar Nomes de Posto',
      manageBank: 'Banco da Guilda',
      manageKick: 'Expulsar Membro',
      manageAssignRank: 'Alterar Posto do Membro',
      save: 'Salvar',
      back: 'Voltar',
      bankBalance: 'Saldo do Banco',
      bankDeposit: 'Depositar',
      bankAmount: 'Valor',
      kickName: 'Nome do Membro',
      kickSubmit: 'Expulsar',
      assignRankName: 'Nome do Membro',
      assignRankValue: 'Posto (0-9)',
      assignRankSubmit: 'Atribuir Posto',
      rankLabel: 'Posto {n}',
      lookupSearch: 'Tag ou Nome',
      lookupInfo: 'Informações da Guilda',
      lookupMembers: 'Lista de Membros',
      lookupName: 'Nome',
      lookupTag: 'Tag',
      lookupDescription: 'Descrição',
      lookupWealth: 'Riqueza',
      lookupCreated: 'Fundada',
      lookupStaff: 'Equipe',
      lookupRank: 'Posto',
      lookupMember: 'Membro',
      notMember: 'Você não está em uma guilda.',
    },
    ping: {
      dialogTitle: 'Ping',
      dialogMin: 'Mín',
      dialogMax: 'Máx',
      dialogAvg: 'Méd',
      ms: 'ms',
      dialogNoData: 'Aguardando dados...',
    },
    cmdPalette: {
      searchPlaceholder: 'Pesquisar comandos…',
      navigate: 'navegar',
      run: 'executar',
      close: 'fechar',
      noResults: 'Nenhum comando encontrado',
      recentlyUsed: 'Usados Recentemente',
      results: 'Resultados',
      all: 'Comandos',
    },
    messages: {
      killedNpc: '{killer} matou {npc}!',
      gainedExp: 'Você ganhou {exp} de EXP!',
      npcDrop: '{item} caiu!',
      expShare: 'Você ganhou {exp} de EXP pelo compartilhamento de grupo!',
      levelUp: 'Parabéns! Você atingiu o nível {level}!',
    },
    lang: {
      en: 'English',
      nl: 'Nederlands',
      sv: 'Svenska',
      pt: 'Português',
    },
    nav: {
      inventory: 'Inventário',
      map: 'Mapa',
      spells: 'Feitiços',
      character: 'Personagem',
      quests: 'Missões',
      social: 'Social',
      bot: 'Bot',
      discord: 'Discord',
      settings: 'Configurações',
      refresh: 'Atualizar',
      exit: 'Sair',
    },
  },
} as const;

export type LocaleKey = keyof typeof locales;
export type LocaleStrings = (typeof locales)[LocaleKey];

export const defaultLocale: LocaleKey = 'en';

export function formatLocaleString(
  str: string,
  params: Record<string, string>,
): string {
  return str.replace(/{(\w+)}/g, (_, key) => {
    return params[key] !== undefined ? params[key] : `{${key}}`;
  });
}
